
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  createProduct, 
  deleteProduct, 
  bulkCreateProducts, 
  createDetailedProduct,
  bulkCreateDetailedProducts,
  updateProduct 
} from '@/services/productService';

export const useCreateProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (productName: string) => createProduct(productName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};

export const useCreateDetailedProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (product: {
      name: string;
      category?: string;
      description?: string;
      unit_of_measure?: string;
    }) => createDetailedProduct(product),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (product: {
      id: string;
      name: string;
      category?: string;
      description?: string | null;
      unit_of_measure?: string;
    }) => updateProduct(product),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};

export const useDeleteProduct = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (productName: string) => deleteProduct(productName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};

export const useBulkCreateProducts = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (productNames: string[]) => bulkCreateProducts(productNames),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};

export const useBulkCreateDetailedProducts = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (products: Array<{
      name: string;
      category?: string | null;
      description?: string | null;
      unit_of_measure?: string;
    }>) => bulkCreateDetailedProducts(products),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] });
      queryClient.invalidateQueries({ queryKey: ['products-with-details'] });
    }
  });
};
